var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaymentApplePay24 = function SvgPaymentApplePay24(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "hide",
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9688 7.76743C12.6668 7.82419 13.3648 7.42682 13.801 6.92301C14.23 6.405 14.5135 5.7096 14.4408 5C13.8228 5.02838 13.0594 5.39737 12.6232 5.91538C12.2233 6.36242 11.8816 7.08621 11.9688 7.76743ZM12.8043 8.25642C13.2575 8.08274 13.8186 7.86772 14.4335 7.90226C14.8261 7.93064 15.9603 8.04418 16.6874 9.09438C16.684 9.09682 16.6766 9.10151 16.6657 9.10846C16.4858 9.22262 15.3432 9.94786 15.3569 11.3793C15.3705 13.0846 16.7939 13.7206 16.9801 13.8038C16.9922 13.8092 17 13.8132 17 13.8132C17 13.8132 16.9978 13.8201 16.9956 13.8268C16.9585 13.9441 16.7137 14.7171 16.1566 15.5091C15.6404 16.2471 15.1097 16.9709 14.2663 16.9851C13.8694 16.992 13.602 16.8792 13.3236 16.7618C13.0308 16.6383 12.7258 16.5097 12.2451 16.5097C11.747 16.5097 11.4281 16.6417 11.121 16.7689C10.8543 16.8794 10.5966 16.9861 10.2384 16.9993C9.4241 17.0277 8.8061 16.2187 8.28989 15.4807C7.23566 13.9906 6.42863 11.2799 7.51921 9.44918C8.04996 8.5338 9.01695 7.95903 10.0566 7.94483C10.5102 7.93678 10.9428 8.10449 11.3211 8.25118C11.6098 8.36313 11.867 8.46284 12.0778 8.46284C12.2657 8.46284 12.5127 8.36819 12.8043 8.25642Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "hide",
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 3.75,
    stroke: "currentColor",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentApplePay24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "PaymentApplePay24.b8c1a314aab234af3ca983b1f0ee5d50.svg";